export const OraMuiCircularProgress = {
  styleOverrides: {
    circle: {
      color: 'var(--type-body-inverse)',
    },
  },
};
